import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';

export type OrganizationBillAddresses = CommonColumns & {
  resourceName: string;
  companyName: string;
  departmentName: string;
  managerName: string;
  managerFamilyName: string;
  managerGivenName: string;
  phoneNumber: string;
  email: string;
  address: string;
  zipCode: string;
  addressLine1: string;
  addressLine2: string;
  sendByMail: string;
};

export const organizationBillAddresses: Readonly<OrganizationBillAddresses> = {
  ...commonColumns,
  ...{
    resourceName: '請求先情報',
    companyName: '企業名',
    departmentName: '所属部署名',
    managerName: 'ご担当者',
    managerFamilyName: 'ご担当者姓',
    managerGivenName: 'ご担当者名',
    phoneNumber: '電話番号',
    email: 'メールアドレス',
    address: '住所',
    zipCode: '郵便番号',
    addressLine1: '請求先住所',
    addressLine2: '請求先住所(建物名以下)',
    sendByMail: '請求書郵送',
  },
};

export const organizationBillAddressesSendByMailName = (
  booleanType: string | boolean
) => {
  if (typeof booleanType === 'boolean') {
    return booleanType ? '必要' : '不要';
  }
  return JSON.parse(booleanType) ? '必要' : '不要';
};
